import queryString from "query-string";

// Completes added as these actions will likely also have multiple dependency calls and we need to know when all of these have completed
export function createAPIActionEntity(name) {
  return {
    CHECK_STALE: `${name}.CHECK_STALE`,
    GET: `${name}.GET`,
    GET_COMPLETE: `${name}.GET_COMPLETE`,
    GET_PDF: `${name}.GET_PDF`,
    GET_TXT: `${name}.GET_TXT`,
    POST: `${name}.POST`,
    POST_COMPLETE: `${name}.POST_COMPLETE`,
    PUT: `${name}.PUT`,
    PUT_COMPLETE: `${name}.PUT_COMPLETE`,
    DELETE: `${name}.DELETE`,
    DELETE_COMPLETE: `${name}.DELETE_COMPLETE`,
    OPERATION: `${name}.OPERATION`,
    OPERATION_COMPLETE: `${name}.OPERATION_COMPLETE`,
    REQUEST: `${name}.REQUEST`,
    RECEIVE: `${name}.RECEIVE`,
    FAILURE: `${name}.FAILURE`,
    PUSHER_UPDATE: `${name}.PUSHER_UPDATE`,
    FULL_REFRESH: `${name}.FULL_REFRESH`,
    PART_REFRESH: `${name}.PART_REFRESH`,
    RESET: `${name}.RESET`
  };
}

// -- ENTITY ACTION CREATORS -- //

export const getEntity = (actionEntity, id, options, dependencies) => {
  if (!actionEntity || !actionEntity.GET) {
    console.warn(
      "actionUtils getEntity :: an actionEntity with a .GET param is required."
    );
    return null;
  }

  if (!id) {
    console.warn("actionUtils getEntity :: an id is required.");
    return null;
  }

  return {
    type: actionEntity.GET,
    payload: { "@id": id },
    options,
    dependencies
  };
};

export const getEntities = (...args) => createGetEntitiesByPageAction(...args);

export const updateEntity = (actionEntity, id, values) => {
  if (!actionEntity || !actionEntity.PUT) {
    console.warn(
      "actionUtils updateEntity :: an actionEntity with a .PUT param is required."
    );
    return null;
  }

  if (!id) {
    console.warn("actionUtils updateEntity :: an id is required.");
    return null;
  }

  return {
    type: actionEntity.PUT,
    payload: {
      ...values,
      "@id": id
    }
  };
};

export const deleteEntity = (actionEntity, id) => {
  if (!actionEntity || !actionEntity.DELETE) {
    console.warn(
      "actionUtils deleteEntity :: an actionEntity with a .DELETE param is required."
    );
    return null;
  }

  if (!id) {
    console.warn("actionUtils deleteEntity :: an id is required.");
    return null;
  }

  return {
    type: actionEntity.DELETE,
    payload: { "@id": id }
  };
};

// -- GENERAL ACTION CREATORS -- //

export function createAction(type, payload) {
  const action = { type };

  if (payload) action.payload = { ...payload };

  return action;
}

export function createActionOptionsObject(
  autoComplete = true,
  showErrorModal = true,
  isFatal = false,
  additionalOptions = {}
) {
  return {
    autoComplete,
    showErrorModal,
    isFatal,
    ...additionalOptions
  };
}

export function createGetEntitiesByPageAction(
  actionEntity,
  endpoint,
  dependencies,
  searchParams,
  payload = {}
) {
  let parsedSearchParams = {
    ...queryString.parse(searchParams)
  };

  // manage non integer page values
  if (parsedSearchParams.page) {
    const page = Number(parsedSearchParams.page);
    if (Number.isInteger(page)) {
      parsedSearchParams.page = page && page > 0 ? page : 1;
    } else {
      parsedSearchParams.page = 1;
    }
  }

  return {
    type: actionEntity.GET,
    dependencies,
    usePages: true,
    payload: {
      endpoint,
      ...parsedSearchParams,
      ...payload
    }
  };
}
